import { handleActions } from "redux-actions";
import {
  SET_LOADING,
  SET_UPDATES_LOADING,
  SET_DATES,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_CHART_SUCCESS,
  UPDATE_DATES,
  SET_FILTERS_DIRTY,
  RESET_FILTER_SELECTED,
  UPDATE_TABLE_VIEW_SELECTED
} from "./activeMembersSagas";

export const initialState = {
  currentUser: {},
  chartData: {},
  isLoading: true,
  updatesLoading: true,
  filtersDirty: false,
  selectedRequestDates: {},
  selectedFilters: {
    period_type: "Monthly",
    table_view: false
  },

};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      updatesLoading: action.payload
    }),
    [SET_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates
    }),
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      filtersDirty: true,
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [RESET_FILTER_SELECTED]: state => ({
      ...state,
      filtersDirty: false,
      selectedFilters: { ...initialState.selectedFilters }
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload
    }),
    [FETCH_CHART_SUCCESS]: (state, action) => ({
      ...state,
      chartData: action.payload
    }),
    [UPDATE_TABLE_VIEW_SELECTED]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        table_view: action.payload
      }
    })
  },
  initialState
);
